import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QuizQuizzesBridge } from './bridges/quiz_quizzes.bridge';
import { QUIZZES_FEATURE_KEY } from './keys';
import { quizzesReducer } from './reducers/quizzes.reducer';
import { QuizzesEffects } from './effects/quizzes.effects';

export function provideQuizzesStore(): EnvironmentProviders[] {
    return [provideState(QUIZZES_FEATURE_KEY, quizzesReducer), provideEffects(QuizzesEffects, QuizQuizzesBridge)];
}
